import { Component, Input, Output, EventEmitter } from '@angular/core';
import { TopicService } from '../topic.service';
import { CryptoService } from '../crypto.service';
import { CryptoView } from '../crypto-view';

@Component({
  selector: 'app-atbash',
  templateUrl: './atbash.component.html',
  styleUrls: ['../topic-style.css','./atbash.component.css']
})
export class AtbashComponent extends CryptoView {

  @Input() current: string;
  @Input() modus: string;
  @Input() direction: string;

  inputs: string[];
  hints: string[] = [];

  constructor(topicService: TopicService, protected cryptoService: CryptoService) {
    super(topicService);
    this.inputs = new Array(26).fill(" ");
  }


   /** used by the html to highlight the correct element */
   currentIndex(): number {
    if (this.modus == "highlight") {
      return this.current.charCodeAt(0) - 65;
    } else if (this.modus == "withoutKey"){
      return this.current.charCodeAt(0) - 65;
    } else {
      return -1;
    }
  }

  /** get the current student mapping */
  getMapping() {
    return this.inputs.join("").slice(0, 26);
  }

  /** set the mapping */
  setmapping(mapping: string) {
    this.inputs = mapping.slice(0, 26).split("");
  }

  /** empty the mapping */
  resetmapping(){
    this.setmapping("                               ")
  }

  /** set the hints */
  setHints(hints: string[]){
    this.hints = hints;
  }

  /** fill the mapping correct */
  fillMapping(){
    for(let i of this.createArray(26)){
      this.inputs[i] = String.fromCharCode(25-i + 65);
    }
  }
    
}
